export default __webpack_public_path__ + "static/media/pasfoto.b8be71c7.png";